import React, { useContext, useEffect, useState } from "react";
import { PastoralContext } from "../../../contexts/PastoralContext";
import styled from "styled-components";
import { convertSeconds, resolveRecordingUrl } from "../../../helpers/utils";
import "./../styles/PastoralCare.css";
import { ProfileContext } from "./../../../contexts/ProfileContext";
import PastoralPagination from "../components/pagination";
import FollowUpFilter from "./followUpFilter";
import { useNavigate, useSearchParams } from "react-router-dom";

export const RecentCallList = (props) => {
  const pastoralContext = useContext(PastoralContext);
  const { getCallLogs, searchValue, sortOrder } = pastoralContext;
  const { worker } = useContext(ProfileContext);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [calls, setCalls] = useState(null);
  const [isLoadingCallLogs, setIsLoadingCallLogs] = useState(true);
  const user_name = worker?.fullName;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSearchParams({ page: pageNumber });
  };

  // Check if user has pastoral_care role
  const isPastoralCare = worker?.role === "pastoral_care";

  // Handle page parameter from URL
  useEffect(() => {
    const pageParam = searchParams.get("page");
    if (pageParam) {
      setCurrentPage(parseInt(pageParam));
    }
  }, [searchParams]);

  useEffect(() => {
    if (!worker) return;

    let cancelled = false;
    setIsLoadingCallLogs(true);

    const request =
      worker.role === "super_admin"
        ? getCallLogs({ direction: "outgoing", page: currentPage })
        : getCallLogs({
            agent_name: user_name,
            direction: "outgoing",
            page: currentPage,
          });

    request
      .then((results) => {
        if (!cancelled) {
          setCalls(results ?? { data: [], total_count: 0 });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCalls({ data: [], total_count: 0 });
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoadingCallLogs(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [currentPage, searchValue, sortOrder, worker, user_name]);

  if (!worker) {
    return (
      <div className="d-flex justify-content-center">
        <div
          className="spinner-border"
          role="status"
          style={{ width: "6em", height: "6em" }}
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col w-full">
        <div className="justify-end">
          <FollowUpFilter
            context={PastoralContext}
            showCallerUserNmber={true}
            showDateRange={true}
          />
        </div>
        <Wrapper className="  m-5 px-3 ">
          <Header className="p-3 mt-4">
            <TableHeading> RECENT CALLS </TableHeading>
            <span></span>
          </Header>
          {isLoadingCallLogs ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5 gap-2">
              <div
                className="spinner-border text-secondary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              />
              <span className="text-secondary" aria-live="polite">
                Processing call logs…
              </span>
            </div>
          ) : calls ? (
            <>
              {/* Render table based on role */}
              {isPastoralCare ? (
                // Pastoral Care Role Design
                <Table>
                  <thead>
                    <TableHeaderRow>
                      <Th>Follow-Up Date</Th>
                      <Th>Caller Name</Th>
                      <Th>Phone Number</Th>
                      <Th>Call Duration</Th>
                      <Th>Audio File</Th>
                    </TableHeaderRow>
                  </thead>
                  <tbody>
                    {calls.total_count > 0 &&
                      calls.data.map((call, index) => {
                        return (
                          <TableRow
                            key={+index}
                            onClick={() =>
                              navigate(
                                "/pastoral-care/" +
                                  call.call_details_id +
                                  "?returnPage=" +
                                  currentPage +
                                  "&returnTo=calllogs"
                              )
                            }
                          >
                            <td className="p-3 text-center">
                              {new Date(call.date).toLocaleDateString("en-US")}
                            </td>
                            <td className="text-center">{call.call_name}</td>
                            <td className="text-center">{call.user_number}</td>
                            <td className="text-center">
                              {convertSeconds(call.call_duration).hours +
                                ":" +
                                convertSeconds(call.call_duration).minutes +
                                ":" +
                                convertSeconds(call.call_duration).seconds}
                            </td>
                            <td className="text-center  ">
                              <div>
                                {resolveRecordingUrl(call.recording) ? (
                                <audio
                                  controls
                                  className="m-1 w-11/12 p-0 audioDiv"
                                  style={{
                                    color: "red",
                                  }}
                                  src={resolveRecordingUrl(call.recording)}
                                  type="audio/ogg"
                                >
                                  Your browser does not support the audio
                                  element.
                                </audio>
                                ) : null}
                              </div>
                            </td>
                          </TableRow>
                        );
                      })}
                  </tbody>
                </Table>
              ) : (
                // Other Roles Design
                <Table className="folloUpTable">
                  <thead>
                    <th>Follow-Up Date</th>
                    <th>Caller Name</th>
                    <th>Phone Number</th>
                    <th>Call Duration</th>
                    <th>Audio File</th>
                  </thead>
                  <tbody>
                    {calls.total_count > 0 &&
                      calls.data.map((call, index) => {
                        return (
                          <TableRow
                            key={+index}
                            onClick={() =>
                              navigate(
                                "/pastoral-care/" +
                                  call.call_details_id +
                                  "?returnPage=" +
                                  currentPage +
                                  "&returnTo=calllogs"
                              )
                            }
                          >
                            <td className="p-3 text-center">
                              {new Date(call.date).toLocaleDateString("en-US")}
                            </td>
                            <td className="text-center">{call.call_name}</td>
                            <td className="text-center">{call.user_number}</td>
                            <td className="text-center">
                              {convertSeconds(call.call_duration).hours +
                                ":" +
                                convertSeconds(call.call_duration).minutes +
                                ":" +
                                convertSeconds(call.call_duration).seconds}
                            </td>
                            <td className="text-center  ">
                              <div>
                                {resolveRecordingUrl(call.recording) ? (
                                <audio
                                  controls
                                  className="m-1 w-11/12 p-0 audioDiv"
                                  style={{
                                    color: "red",
                                  }}
                                  src={resolveRecordingUrl(call.recording)}
                                  type="audio/ogg"
                                >
                                  Your browser does not support the audio
                                  element.
                                </audio>
                                ) : null}
                              </div>
                            </td>
                          </TableRow>
                        );
                      })}
                  </tbody>
                </Table>
              )}
            </>
          ) : null}
        </Wrapper>
        {!isLoadingCallLogs &&
          calls &&
          calls.total_count > itemsPerPage && (
          <PastoralPagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            total_count={calls.total_count}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default RecentCallList;

const Wrapper = styled.div`
  background-color: white;
  border-radius: 20px;
`;

const TableHeading = styled.span`
  color: #ec3310;
  text-align: center;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3.5px;
`;

const TableRow = styled.tr`
  border-bottom-color: #c9cfda;
  border-bottom-width: 1.5px;
  border-bottom-style: solid;
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
`;

// Add TableHeaderRow styled component for pastoral care role
const TableHeaderRow = styled.tr`
  border-bottom-color: #c9cfda;
  border-bottom-width: 1.5px;
  border-bottom-style: solid;
`;

// Add Th styled component for pastoral care role
const Th = styled.th`
  text-align: center;
`;

// Table styles - conditional based on className
const Table = styled.table`
  width: 100%;

  ${(props) =>
    props.className === "folloUpTable"
      ? `
    border: 1px solid #00323b;
    thead {
      font-family: "Futura PT", sans-serif;
      font-size: 16px;
      font-weight: 700;
      flex-shrink: 0;
      border-bottom: 1px solid #00323b;
      background-color: #f1f1f1;
      color: #178b96;
      text-align: center;
      height: 45px;
      letter-spacing: 0.1em;
    }
    tbody {
      text-align: center;
      tr {
      }
      td {
        padding: 0.5em;
        border-bottom: 1px solid #00323b;
        background-color: #fff;
        color: #178b96;
        font-family: "Futura PT", sans-serif;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.1em;
      }
    }
  `
      : `
    // Default styles for pastoral_care role
    font-family: "Space Grotesk";
    thead {
      text-align: center;
    }
    tbody {
      text-align: center;
      td {
        padding: 0.5em;
      }
    }
  `}
`;

const Header = styled.header`
  display: flex;
  justify-content: center;
  width: 100%;
`;
